import React, { useEffect, useState } from "react"

import { isNumber, stringifyDate } from "../../../utils"

export default function SetAxisRangeField({
  missing_value_alt,
  axis_domain,
  label,
  numerical,
  min_label,
  max_label,
  update_field,
  disabled,
}) {
  const [min_value, setMinValue] = useState("")
  const [max_value, setMaxValue] = useState("")

  const getRangeValue = (value, updateFunc) => {
    if (!numerical) {
      updateFunc(stringifyDate(value))
    } else {
      updateFunc(value)
    }
  }

  // Format any passed date values to what input expects
  useEffect(() => {
    getRangeValue(axis_domain[0], setMinValue)
    getRangeValue(axis_domain[1], setMaxValue)
  }, [axis_domain])

  return (
    <div className={"col-4 card"} style={{ padding: "5px" }}>
      <div className={"card-header"}>
        <span className={"card-title"} style={{ marginBottom: "0" }}>
          <b>{label}</b>
        </span>
      </div>
      <div className={"row card-body"} style={{ margin: "0" }}>
        {numerical ? (
          <>
            <div className={"col-6"} style={{ padding: "0" }}>
              <label>{min_label}:</label>&nbsp;
              {!disabled ? (
                <input
                  type={"number"}
                  onWheel={(e) => e.target.blur()}
                  step={"0.1"}
                  style={{ width: "100%" }}
                  value={isNumber(min_value) ? min_value : ""}
                  disabled={disabled}
                  onChange={(e) => {
                    e.preventDefault()
                    update_field([
                      isNumber(e.target.value) ? e.target.value : null,
                      isNumber(max_value) ? max_value : null,
                    ])
                  }}
                />
              ) : (
                <span>{isNumber(min_value) ? min_value : missing_value_alt}</span>
              )}
            </div>
            <div className={"col-6"} style={{ padding: "0" }}>
              <label>{max_label}:</label>&nbsp;
              {!disabled ? (
                <input
                  type={"number"}
                  onWheel={(e) => e.target.blur()}
                  step={"0.1"}
                  style={{ width: "100%" }}
                  value={isNumber(max_value) ? max_value : ""}
                  disabled={disabled}
                  onChange={(e) => {
                    e.preventDefault()
                    update_field([
                      isNumber(min_value) ? min_value : null,
                      isNumber(e.target.value) ? e.target.value : null,
                    ])
                  }}
                />
              ) : (
                <span>{isNumber(max_value) ? max_value : missing_value_alt}</span>
              )}
            </div>
          </>
        ) : (
          <div className={"col-12"} style={{ padding: "0" }}>
            <div style={{ marginBottom: "10px" }}>
              <label>{min_label}:</label>&nbsp;
              {!disabled ? (
                <input
                  type={"datetime-local"}
                  className={"form-control form-control-sm"}
                  value={min_value ? min_value : ""}
                  disabled={disabled}
                  onChange={(e) => {
                    e.preventDefault()
                    update_field([e.target.value ? e.target.value : null, max_value ? max_value : null])
                  }}
                />
              ) : (
                <span>{min_value ? min_value : missing_value_alt}</span>
              )}
            </div>
            <div>
              <label>{max_label}:</label>&nbsp;
              {!disabled ? (
                <input
                  type={"datetime-local"}
                  className={"form-control form-control-sm"}
                  value={max_value ? max_value : ""}
                  disabled={disabled}
                  onChange={(e) => {
                    e.preventDefault()
                    update_field([min_value ? min_value : null, e.target.value ? e.target.value : null])
                  }}
                />
              ) : (
                <span>{max_value ? max_value : missing_value_alt}</span>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
